module.exports = __webpack_public_path__ + "static/img/MADRID_MAPLE.3ca5961.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/materials/Frendel/MADRID_MAPLE.jpg
// module id = LdY9
// module chunks = 0